import React, { useMemo } from 'react'
import { makeStyles, Icon } from '@material-ui/core'
import { successes, warnings, errors, gray } from '../../utils/colors'
import { FONT_WEIGHTS } from '../../utils'

// @TODO - This should replace the WizardAlert component in all Wizards.
/**
 *
 * @param {{type: 'success' | 'warning' | 'error' | 'info', text: string, style: object}} param0
 * @returns
 */
const StyledAlert = ({ type = 'success', text = '', style = {} }) => {
	const classes = useStyles({ type })()

	const icon = useMemo(() => {
		if (type === 'success') {
			return (
				<Icon
					className="fa fa-check-circle"
					style={{
						fontSize: '0.8rem',
						fontWeight: '400',
						color: successes[500],
						overflow: 'unset'
					}}
				/>
			)
		}
		if (type === 'info') {
			return (
				<Icon
					className="fa fa-info-circle"
					style={{ fontSize: '0.8rem', fontWeight: '400', color: successes[500], overflow: 'unset' }}
				/>
			)
		}
		if (type === 'warning') {
			return (
				<Icon
					className="fa fa-exclamation-circle"
					style={{ fontSize: '0.8rem', fontWeight: '400', color: warnings[500], overflow: 'unset' }}
				/>
			)
		}
		if (type === 'error') {
			return (
				<Icon
					className="fa fa-exclamation-circle"
					style={{
						fontSize: '0.8rem',
						fontWeight: '400',
						color: errors[500],
						overflow: 'unset'
					}}
				/>
			)
		}
		return null
	}, [type])

	return (
		<div className={classes.root} style={{ ...style }}>
			<div className={classes.iconContainer}>{icon}</div>
			<div className={classes.textContainer}>{text}</div>
		</div>
	)
}

const useStyles = ({ type }) =>
	makeStyles(() => ({
		root: {
			backgroundColor:
				type === 'success' || type === 'info'
					? successes[10]
					: type === 'warning'
					? warnings[100]
					: type === 'error'
					? errors[10]
					: gray[100],
			padding: '.5rem .8rem',
			borderRadius: '.375rem',
			display: 'flex',
			gap: '.8rem'
		},
		iconContainer: {
			display: 'flex',
			alignItems: 'center'
		},
		textContainer: {
			flex: 1,
			fontFamily: 'Nunito',
			fontSize: '0.875rem',
			display: 'flex',
			alignItems: 'center',
			fontWeight: FONT_WEIGHTS.Regular,
			color:
				type === 'success' || type === 'info'
					? successes[500]
					: type === 'warning'
					? warnings[500]
					: type === 'error'
					? 'black'
					: gray[500]
		}
	}))

export default StyledAlert
